import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import { configureStore } from "./store/store";

const root = ReactDOM.createRoot(
    document.getElementById('root')
);
root.render(
    <Provider store={configureStore({})}>
        <React.StrictMode>
            <App/>
        </React.StrictMode>
    </Provider>
);

reportWebVitals();
